import { GLOBAL_QUERY_OPTIONS } from '@ps/common-features/lib/api/constants/apiOptions'
import type { BaseQueryOptions } from '@ps/common-features/lib/api/types/query'
import { useQuery } from '@tanstack/react-query'

import { serviceTrackingKeys } from '../serviceTracking.keys'
import { getServiceTracking } from '../serviceTracking.service'
import { TrackingData } from '../serviceTracking.types'

type UseGetRequestTrackingProps = {
  code?: string
  options?: BaseQueryOptions<TrackingData>
}

export const useGetRequestTracking = ({ code, options }: UseGetRequestTrackingProps) => {
  return useQuery({
    queryKey: serviceTrackingKeys.get(code!),
    queryFn: () => getServiceTracking(code!),
    enabled: !!code,

    ...GLOBAL_QUERY_OPTIONS,
    ...options,
  })
}
